import React from "react";

const videos = [
  {
    title: "TV2 Mokka 07.14 2023",
    url: "https://www.youtube.com/embed/NYw3VuUc5JA?si=ycofv1wazGIW69gA",
  },
  {
    title: "ARTI SYAL MOKKA 05.12",
    url: "https://www.youtube.com/embed/q58gmzdniKs?si=VhKqPGp7Cxy3-KKj",
  },
  {
    title: "20230414 MOKKACINO ARTI SYAL",
    url: "https://www.youtube.com/embed/pUvXF8P5eyE?si=-xJdQpNINZ60eHPi",
    desc:
      "Mrs Arti Syal and our Co-Founder, Ms Mészáros Ildikó, appeared on TV2 Mokka, discussing our mission to promote business opportunities between India, Hungary, and neighbouring countries.",
  },
  {
    title: "Mrs Arti Syal | Visionary Address at Indo European Business Excellence Awards 2025",
    url: "https://www.youtube.com/embed/Pn3Ywn-ilrM?si=9tK8jDCzeL69iBNo",
    desc: `Mrs Arti Syal, Chairwoman of IEBC, shares her vision for India-Hungary economic collaboration at the Indo European Business Excellence Awards & Summit 2025, highlighting the mission of IEBC and the growing partnership between the two countries.`,
  },

  {
    title: "2000+ German Companies in India?! 🇮🇳🇩🇪 Shocking Growth Explained",
    url: "https://www.youtube.com/embed/XbdNc-DvNfQ?si=6QuHq89kprquIcZr",
    desc: `Highlights from the visit of German Chancellor Friedrich Merz to India, with Mrs Arti Syal discussing the growing interest in India–Germany business ties. Over 2000 German companies now operate in India, reflecting deepening economic and strategic partnerships between the two nations.`
  },
];

const YTVideos = () => {
  return (
    <section className="py-16 px-4 bg-gradient-to-b from-blue-50 via-white to-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-Agatho_Regular font-bold text-center text-[#0B1D33] pb-2 mb-4">
          Explore Our Interviews
        </h2>
        <p className="mb-10 text-center text-lg text-gray-600 font-medium">
          Dive into stories, events, and insights with our curated video collection.
        </p>
        <div className="flex flex-col md:flex-row md:flex-wrap gap-10">
          {videos.map((video, idx) => (
            <div
              key={idx}
              className="rounded-xl transition duration-300 overflow-hidden flex flex-col flex-1 md:basis-[45%] min-w-0 mx-auto" 
              style={{ minWidth: '300px', maxWidth: '50%' }}
            >
              <div className="relative w-full pt-[56.25%]">
                <iframe
                  src={video.url}
                  title={video.title}
                  width="560"
                  height="315"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  className="absolute top-0 left-0 w-full h-full rounded-t-xl"
                ></iframe>
              </div>
              {(video.desc || video.title) && (
                <div className="p-5 flex-1 flex flex-col items-center justify-center">
                  {video.title && (
                    <h3 className="text-xl md:text-2xl font-bold text-[#0B1D33] text-center leading-tight mb-2">
                      {video.title}
                    </h3>
                  )}
                  {video.desc && (
                    <p className="text-base text-gray-700 text-center">
                      {video.desc}
                    </p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
   
      </div>
    </section>
  );
};

export default YTVideos;
